module.exports = __webpack_public_path__ + "img/testicular-cancer-leaflet.0bd8d640.jpg";